module.exports = __webpack_public_path__ + "img/herov2.38b7f951.png";